// import $ from "jquery";
import slick from "slick-carousel";
import matchHeight from "jquery-match-height";
import {
  breakpoints,
  matchBreakpoint,
  slickItemsCounter
} from "../common/utils";

(() => {
  const slickInit = {
    init() {
      this.productLoop();
      this.blogVideo();
      this.productRelatedPosts();
      this.productRelatedProducts()
    },

    productRelatedPosts() {
      const slider = $(".product-advice-slider__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="product-advice-slider__arrow product-advice-slider__arrow--prev"></span>',
        nextArrow:
          '<span class="product-advice-slider__arrow product-advice-slider__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    productRelatedProducts() {
      const slider = $(".product-related-products__slider");

      slider.slick({
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false,
        variableWidth: true,
        prevArrow:
          '<span class="product-related-products__arrow product-related-products__arrow--prev"></span>',
        nextArrow:
          '<span class="product-related-products__arrow product-related-products__arrow--next"></span>',
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 400,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    },
    blogVideo() {
      const slider = $("[data-new-slider]");

      slider.each(function() {
        let self = $(this);
        const sliderData = self.data("new-slider");
        const dataSlides = self.parent().find("[data-" + sliderData + "]");
        let sliderSlides = dataSlides.data(sliderData);
        let sliderSlidesMobile = 1;
        let sliderSlidesIpad = 1;
        let sliderSlidesIpadPro = 1;
        let arrNext = $(".blog-slider-arrows--next");

        self.on("init reInit afterChange", function(
          event,
          slick,
          currentSlide
        ) {
          if (
            slick.$slides.length > 1 &&
            slick.$slides.length == currentSlide + slick.options.slidesToScroll
          ) {
            self.addClass("show-mask");
          } else {
            self.removeClass("show-mask");
          }

          if (
            (!self.find(".blog-slider-arrows--next").length > 0 ||
              self
                .find(".blog-slider-arrows--next")
                .hasClass("slick-disabled")) &&
            self.find(".blog-slider-arrows--prev").length > 0
          ) {
            self.addClass("hide-after");
          } else {
            self.removeClass("hide-after");
          }
        });

        if (sliderSlides != 1) {
          self.removeClass("video-slider--large");
          sliderSlidesMobile = 1.5;
          sliderSlidesIpad = 2.5;
          sliderSlidesIpadPro = 3.5;
        }

        if (sliderSlides >= 3 && !self.hasClass("const-num")) {
          sliderSlides = 3.5;
        }

        if ($("[data-video-slider-slides]").hasClass("video-full")) {
          sliderSlides = 4.5;
        }

        self.slick({
          dots: false,
          infinite: false,
          speed: 600,
          slidesToShow: sliderSlides,
          slidesToScroll: 2,
          centerPadding: "20px",
          prevArrow:
            '<span class="blog-slider-arrows blog-slider-arrows--prev"></span>',
          nextArrow:
            '<span class="blog-slider-arrows blog-slider-arrows--next"></span>',
          responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: sliderSlidesIpadPro,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 799,
              settings: {
                slidesToShow: sliderSlidesIpad,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: sliderSlidesMobile,
                slidesToScroll: 1
              }
            }
          ]
        });
      });
    },
    productLoop() {
      const slider = $("[data-loop-products]");

      slider.on("init reInit afterChange", slickItemsCounter);

      slider.slick({
        dots: true,
        infinite: false,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 3,
        prevArrow:
          '<span class="c-box-top-products__arrows c-box-top-products__arrows--prev"></span>',
        nextArrow:
          '<span class="c-box-top-products__arrows c-box-top-products__arrows--next"></span>',
        dotsClass: "c-box-top-products__dots",
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.2,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  };

  slickInit.init();
})();
